import React from 'react';
import { Modal, Link } from '@mui/material';
import { useIntl } from 'react-intl';
import { StyledBox, StyledBoxContent, StyledModalTitle, StyledModalText } from './styles';
import { pyxirRocket } from 'Assets/img/home-option-icons';
import { AppMigrationTakeoverModalModuleStore } from './AppMigrationTakeoverModalModuleStore';
import { Capacitor } from '@capacitor/core';

function AppMigrationTakeoverModal() {
  const intl = useIntl();
  const store = AppMigrationTakeoverModalModuleStore.Instance().Use();
  const isOpen = store.IsOpen;

  // Determine app store link based on platform
  const platform = Capacitor.getPlatform();

  const getAppStoreLink = () => {
    switch (platform) {
      case 'ios':
        return 'https://apps.apple.com/us/app/hi-pyx/id6747408015';
      case 'android':
        return 'https://play.google.com/store/apps/details?id=io.drivershealth.app';
      default:
        return 'https://hipyx.pyxhealth.com/';
    }
  };

  const appStoreLink = getAppStoreLink();

  return (
    <Modal
      open={isOpen}
      style={{ zIndex: 1500 }}
      // No onClose handler - user cannot dismiss this modal
      disableEscapeKeyDown
      hideBackdrop={true}
    >
      <StyledBox>
        <StyledBoxContent>
          <img
            alt={intl.formatMessage({ id: 'image.pyxir.portrait' })}
            src={pyxirRocket}
            style={{ marginBottom: '12px' }}
          />
          <StyledModalTitle component="h1">
            {intl.formatMessage({ id: 'modal.app-migration-takeover.title' })}
          </StyledModalTitle>
          <StyledModalText>
            {intl.formatMessage({ id: 'modal.app-migration-takeover.content' })}{' '}
            <Link href={appStoreLink} target="_blank" rel="noopener noreferrer" color="inherit" underline="always">
              {intl.formatMessage({ id: 'modal.app-migration-takeover.link' })}
            </Link>
          </StyledModalText>
          <StyledModalText style={{ fontWeight: 'bold', marginTop: '24px' }}>
            {intl.formatMessage({ id: 'modal.app-migration-takeover.footer' })}
          </StyledModalText>
        </StyledBoxContent>
      </StyledBox>
    </Modal>
  );
}

export default AppMigrationTakeoverModal;
